import { useActiveAddress } from "@arweave-wallet-kit/react"
import { Link, Stack, Typography } from "@mui/material"
import { useQuery } from "@tanstack/react-query"
import { ArrowNarrowRight } from "@untitled-ui/icons-react"
import { useContext } from "react"

import { ActivityRow } from "./ActivityRow"
import { ActivitySkeleton } from "./ActivitySkeleton"
import { getActivity } from "../../ao/activity-api"

import { ConfigContext } from "../../contexts/config"
import { RECENT_ACTIVITY } from "../../settings"
import { createLogger } from "../../utils/logger"
import { ErrorBoundary } from "../ErrorBoundary"

const logger = createLogger("Activity")

export function Activity() {
  // active address
  const activeAddr = useActiveAddress()

  // config
  const [config] = useContext(ConfigContext)

  const { data: activities } = useQuery({
    queryKey: [`activity_${activeAddr}`, activeAddr, config],
    enabled: !!activeAddr,
    queryFn: async () => {
      if (!activeAddr) throw new Error("Params missing")

      const [, result] = await getActivity(RECENT_ACTIVITY, undefined, false, activeAddr)

      logger.log("onPastActivities", result)
      return result
    },
  })

  return (
    <>
      <Typography>Past Activity</Typography>
      <Stack gap={1}>
        {!activities &&
          Array.from({ length: RECENT_ACTIVITY }).map((_, index) => (
            <ActivitySkeleton key={index} />
          ))}
        {activities?.length === 0 && (
          <Typography color="secondary">
            Start using Botega before you can see your activity.
          </Typography>
        )}
        {activities?.map((activity, index) => (
          <ErrorBoundary key={index} fallback={<>Something went wrong</>}>
            <ActivityRow activity={activity} />
          </ErrorBoundary>
        ))}
        {activities && activities.length === 5 && (
          <Link
            href={`https://dexi.arweave.net/#/entity/${activeAddr}`}
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              gap: 0.5,
              display: "flex",
              alignItems: "center",
              flexDirection: "row",
              justifyContent: "center",
              fontSize: "0.875rem",

              "& svg": {
                color: "var(--mui-palette-accent-main)",
                width: "1.1rem",
                height: "1.1rem",
              },
            }}
            color="text.primary"
            underline="hover"
          >
            View All Activity
            <ArrowNarrowRight />
          </Link>
        )}
      </Stack>
    </>
  )
}
